export const CreditPackBreakdown = ({ pack, prefix }) => (
  <div className="mt-2 space-y-1 text-xs leading-relaxed [overflow-wrap:anywhere]">
    <p data-testid={`${prefix}-base`} className="text-white/50">{pack.base_credits.toLocaleString()} base</p>
    <p data-testid={`${prefix}-bonus`} className="text-emerald-300">+{pack.bonus_credits.toLocaleString()} bonus ({Math.round(pack.bonus_pct * 100)}%)</p>
    <p data-testid={`${prefix}-rate`} className="text-white/60">{pack.credits_per_usd.toLocaleString(undefined, { maximumFractionDigits: 2 })} credits / $1</p>
  </div>
);